export default "__VITE_ASSET__Cit26y2t__"